/** @format */

import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import moment from 'moment';
import i18next from 'i18next';
import { ExportToCsv } from 'export-to-csv';

interface PrefixToCsvInterface {
    id: number;
    mainname: string;
    prefix: string;
    type: string;
    fractionId: string;
    usageFlag: string;
}

export class PrefixToCsv {
    private readonly itemLoader: ItemLoaders;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoader = itemLoader;
    }

    exportToCsv = (): void => {
        const extendFilter = [];

        extendFilter.push({ name: 'itemsPerPage', value: 99999999 });

        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/prefixes')),
            'prefix_get_list',
            extendFilter,
            [],
            (items: any): void => {
                this.preparePrefixSchemCSV(items);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    preparePrefixSchemCSV = (items: any): void => {
        const csvList = this.prepareCsvData(items);
        const options = {
            filename: i18next.t('prefixes:h.prefix_list') + '_' + moment().format('YYYYMMDD[_]HHmm'),
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            title: i18next.t('prefixes:h.prefix_list'),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [
                i18next.t('prefixes:h.prefix_id'),
                i18next.t('prefixes:h.prefix_name'),
                i18next.t('prefixes:h.prefix_value'),
                i18next.t('prefixes:h.type'),
                i18next.t('prefixes:h.fraction'),
                i18next.t('prefixes:h.generate_cdr'),
            ],
        };
        const exportCsv = new ExportToCsv(options);
        exportCsv.generateCsv(csvList);
    };

    prepareCsvData = (items: any): Array<PrefixToCsvInterface> => {
        const csvList: Array<PrefixToCsvInterface> = [];
        if (items['hydra:member'] && items['hydra:totalItems'] && items['hydra:totalItems'] > 0) {
            items['hydra:member'].map((item: any) => {
                csvList.push({
                    id: item.id,
                    mainname: item.mainname,
                    prefix: item.prefix,
                    type: item.type,
                    fractionId: item.fractionId,
                    usageFlag: item.usageFlag,
                });
            });
        }
        return csvList;
    };
}
